/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetSupportContactStatusRequest} from '@cash-web/protos/squareup/franklin/support.pb'
import {GetSupportContactStatusResponse} from '@cash-web/protos/squareup/franklin/support.pb'


export const getSupportContactStatus = (request:GetSupportContactStatusRequest, options?: CashRequestOptions) => post<GetSupportContactStatusRequest, GetSupportContactStatusResponse>("/2.0/cash/get-support-contact-status", request, {...options, rejectOnError: true })